/** Puts the site theme on <html> with color transitions off for that one style pass
 *  (`.theme-switching` in tailwind.css): the whole page swaps in a single frame, and a
 *  quick double toggle has nothing half-done to leave behind. */
export const applySiteTheme = (isDark: boolean, doc: Document = document) => {
	const root = doc.documentElement;
	if (root.classList.contains("dark") === isDark) return;

	root.classList.add("theme-switching");
	root.classList.toggle("dark", isDark);
	// Forces the style pass while the switch class is on; otherwise the browser would see
	// the new colors only after it is gone and fade them anyway.
	const flushStyles = () => doc.defaultView?.getComputedStyle(doc.body).getPropertyValue("color");
	flushStyles();
	// Effects that follow the theme (the chat's colors) land before this, so they switch unfaded too.
	setTimeout(() => {
		flushStyles();
		root.classList.remove("theme-switching");
	}, 0);
};
